<section class="central-entry" [attr.aria-busy]="!error">
  <ng-container *ngIf="!error">
    <div class="central-entry-bar" aria-hidden="true">
      <div class="central-entry-tabs"><span></span><span></span><span></span><span></span></div>
      <div class="central-entry-selector"><span></span><span></span></div>
    </div>
    <div class="central-entry-body">
      <app-profile-skeleton *ngIf="profilePage; else centralPage"></app-profile-skeleton>
      <ng-template #centralPage><app-central-skeleton [page]="skeletonPage"></app-central-skeleton></ng-template>
    </div>
  </ng-container>
  <div *ngIf="error" class="central-entry-error">
    <p role="alert">{{ error }}</p>
    <button type="button" class="btn btn-primary" (click)="open()">Try again</button>
    <a routerLink="/streaker-central" queryParamsHandling="preserve">Open Streaker Central</a>
  </div>
</section>
